import React, { forwardRef } from 'react';
import { HBInputProps } from './HBInput.types';
import { stopEventPropagation } from '../../utils/shared.utils';

const InputBase = forwardRef<HTMLInputElement, HBInputProps>((props, ref) => {
    const {
        size,
        scope,
        customTheme,
        error,
        width,
        blurOnEnterKey,
        onEnterKey,
        selectOnFocus,
        inputStyle,
        prefix,
        suffix,
        clearable,
        onClear,
        tags,
        onTagRemove,
        ...baseProps
    } = props;

    return (
        <input
            ref={ref}
            autoComplete="off"
            {...baseProps}
            onPaste={baseProps?.onPaste || stopEventPropagation}
        />
    );
});

export default InputBase;
